import { render, staticRenderFns } from "./chart2.vue?vue&type=template&id=56708fd5&scoped=true"
import script from "./chart2.vue?vue&type=script&lang=js"
export * from "./chart2.vue?vue&type=script&lang=js"
import style0 from "./chart2.vue?vue&type=style&index=0&id=56708fd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56708fd5",
  null
  
)

export default component.exports